import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import { CheckCircle } from "lucide-react";
import "./homeLanding.css";
import homePageImage1 from "../../images/homePageImages/homepageimage1.png";
import homePageImage4 from "../../images/homePageImages/homepageimage4.png";
import homePageImage9 from "../../images/homePageImages/homepageimage9.png";
import PhoneCarousel from "../common/phoneCarousel/PhoneCarousel";

const screenshots = [
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/bookingModalScreenshots.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/calendarScreenshot.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/editShopScreenshots.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/shopScreenshots.png",

]

const HomeLanding = () => {
    const { language } = useContext(CombinedContext);
    const navigate = useNavigate();

    return (
        <div>
            <section className="sf-homelanding-hero">
                <div className="sf-homelanding-hero-sub-div">
                    <div className="sf-homelanding-text-div">
                        <h1>{translations[language].homeLanding.hero.title}</h1>

                        <p>{translations[language].homeLanding.hero.subtitle}</p>

                        <div className="sf-homelanding-hero-actions">
                            <button className="sf-bl-btn-primary" onClick={() => navigate("/businesslanding")}>
                                {translations[language].homeLanding.hero.primaryCta}
                            </button>

                            <button className="sf-bl-store" onClick={() => navigate("/barbershop")}>
                                {translations[language].homeLanding.hero.secondaryCta}
                            </button>
                        </div>

                        <p className="sf-homelanding-platforms">
                            <em>
                                <strong>{translations[language].homeLanding.hero.platformStrong}</strong>
                                {translations[language].homeLanding.hero.platformRest}
                            </em>
                        </p>
                    </div>

                    <img src={homePageImage9} className="sf-homelanding-graphic" alt="hero" />
                </div>
            </section>
            <div className="sf-homelanding-section1">
                {/* HERO */}

                <section className="sf-homelanding-section">
                    <div className="sf-homelanding-text-div">
                        <h2>{translations[language].homeLanding.whatWeDo.title}</h2>

                        <ul>
                            <li>
                                <span>1</span>
                                <div>
                                    <div className="sf-homelanding-text strong">
                                        {translations[language].homeLanding.businessPoints[0].title}
                                    </div>
                                    <div className="sf-homelanding-text">
                                        {translations[language].homeLanding.businessPoints[0].desc}
                                    </div>
                                </div>
                            </li>

                            <li>
                                <span>2</span>
                                <div>
                                    <div className="sf-homelanding-text strong">
                                        {translations[language].homeLanding.businessPoints[1].title}
                                    </div>
                                    <div className="sf-homelanding-text">
                                        {translations[language].homeLanding.businessPoints[1].desc}
                                    </div>
                                </div>
                            </li>

                            <li>
                                <span>3</span>
                                <div>
                                    <div className="sf-homelanding-text strong">
                                        {translations[language].homeLanding.businessPoints[2].title}
                                    </div>
                                    <div className="sf-homelanding-text">
                                        {translations[language].homeLanding.businessPoints[2].desc}
                                    </div>
                                </div>
                            </li>

                            <li>
                                <span>4</span>
                                <div>
                                    <div className="sf-homelanding-text strong">
                                        {translations[language].homeLanding.businessPoints[3].title}
                                    </div>
                                    <div className="sf-homelanding-text">
                                        {translations[language].homeLanding.businessPoints[3].desc}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <PhoneCarousel />
                </section>

                {/* BENEFITS BUSINESS */}
                <section className="sf-benefit-row">
                    <img src={homePageImage1} alt="benefit" />

                    <div className="sf-homelanding-card">
                        <h3>{translations[language].homeLanding.business.title}</h3>

                        <p>{translations[language].homeLanding.business.intro}</p>

                        <ul>
                            {translations[language].homeLanding.business.items.map((item, idx) => (
                                <li key={idx}>
                                    <CheckCircle size={18} /> {item}
                                </li>
                            ))}
                        </ul>

                        <button className="sf-bl-btn-primary" onClick={() => navigate("/businesslanding")}>
                            {translations[language].homeLanding.business.cta}
                        </button>
                    </div>
                </section>

                {/* BENEFITS CLIENT */}
                <section className="sf-benefit-row reverse">
                    <div className="sf-homelanding-card">
                        <h3>{translations[language].homeLanding.clients.title}</h3>

                        <p>{translations[language].homeLanding.clients.intro}</p>

                        <ul>
                            {translations[language].homeLanding.clients.items.map((item, idx) => (
                                <li key={idx}>
                                    <CheckCircle size={18} /> {item}
                                </li>
                            ))}
                        </ul>

                        <button className="sf-bl-store" onClick={() => navigate("/barbershop")}>
                            {translations[language].homeLanding.clients.cta}
                        </button>
                    </div>

                    <img src={homePageImage4} alt="benefit" />
                </section>

                {/* HOW IT WORKS */}
                <section className="sf-how">
                    <h2>{translations[language].homeLanding.about.title}</h2>

                    <div className="sf-steps">
                        <svg className="sf-steps-line" viewBox="0 0 1000 200" preserveAspectRatio="none">
                            <path
                                d="M 50 100 C 300 0, 700 200, 950 100"
                                stroke="#1f6c8b"
                                strokeWidth="2"
                                fill="none"
                                strokeDasharray="6 6"
                            />
                        </svg>

                        <div className="sf-step">
                            <div className="sf-step-circle">
                                <strong>{translations[language].homeLanding.about.step1}</strong>
                                {translations[language].homeLanding.about.step1Text}
                            </div>

                            <p>{translations[language].homeLanding.about.paragraph1}</p>
                        </div>

                        <div className="sf-step">
                            <div className="sf-step-circle">
                                <strong>{translations[language].homeLanding.about.step2}</strong>
                                {translations[language].homeLanding.about.step2Text}
                            </div>

                            <p>{translations[language].homeLanding.about.paragraph2}</p>
                        </div>

                        <div className="sf-step">
                            <div className="sf-step-circle">
                                <strong>{translations[language].homeLanding.about.step3}</strong>
                                {translations[language].homeLanding.about.step3Text}
                            </div>

                            <p>{translations[language].homeLanding.about.paragraph3}</p>
                        </div>
                    </div>
                </section>

                {/* CTA */}
                <section className="sf-homelanding-mini-cta">
                    <p>{translations[language].homeLanding.finalCta.text}</p>

                    <button className="sf-bl-btn-primary" onClick={() => navigate("/businesslanding")}>
                        {translations[language].homeLanding.business.cta}
                    </button>
                </section>

                {/* TESTIMONIALS */}
                <section className="sf-testimonials">
                    <h2>What our clients are saying</h2>

                    <div className="sf-testimonial-grid">
                        <div className="sf-testimonial">TESTIMONIALS</div>
                        <div className="sf-testimonial">TESTIMONIALS</div>
                        <div className="sf-testimonial">TESTIMONIALS</div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default HomeLanding;

// import React, { useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import { CombinedContext } from "../../context/combinedContext";
// import translations from "../../translations/translations";
// import { CheckCircle } from "lucide-react";
// import "./homeLanding.css";
// import homePageImage1 from "../../images/homePageImages/homepageimage1.png";
// import homePageImage4 from "../../images/homePageImages/homepageimage4.png";

// const HomeLanding = () => {
// 	const { language } = useContext(CombinedContext);
// 	const navigate = useNavigate();

// 	return (
// 		<div className="sf-homelanding-section1">

// 			{/* HERO */}
// 			<section className="sf-homelanding-hero">

// 				<div className="sf-homelanding-text-div">

// 					<h1>{translations[language].homeLanding.hero.title}</h1>
// 					<p>{translations[language].homeLanding.hero.subtitle}</p>

// 					<div className="sf-homelanding-hero-actions">
// 						<button
// 							className="btn brand"
// 							onClick={() => navigate("/businesslanding")}
// 						>
// 							{translations[language].homeLanding.hero.primaryCta}
// 						</button>

// 						<button
// 							className="btn outline"
// 							onClick={() => navigate("/barbershop")}
// 						>
// 							{translations[language].homeLanding.hero.secondaryCta}
// 						</button>
// 					</div>

// 					<p className="sf-homelanding-platforms">
// 						{translations[language].homeLanding.hero.platformText}
// 					</p>

// 				</div>

// 				<img
// 					src={homePageImage1}
// 					className="sf-homelanding-graphic"
// 					alt="hero"
// 				/>

// 			</section>

// 			{/* WHY BUSINESSES LOVE */}
// 			<section className="sf-homelanding-section">

// 				<div className="sf-homelanding-text-div">

// 					<h2>Why businesses love Sin Fila</h2>

// 					<ul>

// 						<li>
// 							<span>1</span>
// 							<div>
// 								<strong>Never miss a booking</strong>
// 								<p>All appointments, confirmations, and reminders in one place.</p>
// 							</div>
// 						</li>

// 						<li>
// 							<span>2</span>
// 							<div>
// 								<strong>Attract new clients</strong>
// 								<p>Show your business to more clients in our marketplace.</p>
// 							</div>
// 						</li>

// 						<li>
// 							<span>3</span>
// 							<div>
// 								<strong>Save time managing your shop and staff</strong>
// 								<p>Manage your services and staff calendars effortlessly.</p>
// 							</div>
// 						</li>

// 						<li>
// 							<span>4</span>
// 							<div>
// 								<strong>Effortless bookings for your clients</strong>
// 								<p>Clients book, modify, and get reminders automatically.</p>
// 							</div>
// 						</li>

// 					</ul>

// 				</div>

// 				{/* Screenshot stack */}
// 				<div className="sf-homelanding-graphic-stack">

// 					<div></div>
// 					<div></div>
// 					<div></div>

// 					<div>
// 						Flip through 4 screenshots
// 					</div>

// 				</div>

// 			</section>

// 			{/* BENEFITS BUSINESS */}
// 			<section className="sf-benefit-row">

// 				<img src={homePageImage1} alt="benefit" />

// 				<div className="sf-homelanding-card">

// 					<h3>Key benefits for businesses</h3>

// 					<ul>
// 						{translations[language].homeLanding.business.items.map((item, idx) => (
// 							<li key={idx}>
// 								<CheckCircle size={18} /> {item}
// 							</li>
// 						))}
// 					</ul>

// 					<button
// 						className="btn brand small"
// 						onClick={() => navigate("/businesslanding")}
// 					>
// 						{translations[language].homeLanding.business.cta}
// 					</button>

// 				</div>

// 			</section>

// 			{/* BENEFITS CLIENT */}
// 			<section className="sf-benefit-row reverse">

// 				<div className="sf-homelanding-card">

// 					<h3>Key benefits for customers</h3>

// 					<ul>
// 						{translations[language].homeLanding.clients.items.map((item, idx) => (
// 							<li key={idx}>
// 								<CheckCircle size={18} /> {item}
// 							</li>
// 						))}
// 					</ul>

// 					<button
// 						className="btn outline small"
// 						onClick={() => navigate("/barbershop")}
// 					>
// 						{translations[language].homeLanding.clients.cta}
// 					</button>

// 				</div>

// 				<img src={homePageImage4} alt="benefit" />

// 			</section>

// 			{/* HOW IT WORKS */}
// 			<section className="sf-how">

// 				<h2>How it works</h2>

// 				<div className="sf-steps">

// 					<div className="sf-step">

// 						<div className="sf-step-circle">
// 							Step 1
// 						</div>

// 						<p>
// 							Create your business profile, list services, set hours,
// 							and prepare your calendar.
// 						</p>

// 					</div>

// 					<div className="sf-step">

// 						<div className="sf-step-circle">
// 							Step 2
// 						</div>

// 						<p>
// 							Add your staff, assign roles, and manage multiple calendars.
// 						</p>

// 					</div>

// 					<div className="sf-step">

// 						<div className="sf-step-circle">
// 							Step 3
// 						</div>

// 						<p>
// 							Clients can book online instantly with automatic reminders.
// 						</p>

// 					</div>

// 				</div>

// 			</section>

// 			{/* CTA */}
// 			<section className="sf-homelanding-mini-cta">

// 				<p>
// 					Start Now for Free, and take advantage of our attractive referrals program
// 				</p>

// 				<button
// 					className="btn brand"
// 					onClick={() => navigate("/businesslanding")}
// 				>
// 					Go to For Business Section
// 				</button>

// 			</section>

// 			{/* TESTIMONIALS */}
// 			<section className="sf-testimonials">

// 				<h2>What our clients are saying</h2>

// 				<div className="sf-testimonial-grid">

// 					<div className="sf-testimonial">TESTIMONIALS</div>
// 					<div className="sf-testimonial">TESTIMONIALS</div>
// 					<div className="sf-testimonial">TESTIMONIALS</div>

// 				</div>

// 			</section>

// 		</div>
// 	);
// };

// export default HomeLanding;
